import ResizableScene from "../core/ResizableScene";

export type Layer = "bg" | "game" | "foreground";

export class Layers {

	scene: ResizableScene;
	layers: Map<Layer, Phaser.GameObjects.Container>;

	constructor(scene: ResizableScene) {
		this.scene = scene;
		this.layers = new Map<Layer, Phaser.GameObjects.Container>();
	}

	addLayers(parent: Phaser.GameObjects.Container, ...layers: Layer[]): void {
		for (const key of layers) {
			const layer = this.scene.add.container();
			parent.add(layer);
			this.layers.set(key, layer);
		}
	}

	addToLayer(obj: Phaser.GameObjects.GameObject, layer: Layer): void {
		this.get(layer).add(obj);
	}

	get(key: Layer): Phaser.GameObjects.Container {
		return this.layers.get(key);
	}

}